{
    "TelephoneserverLabel": "Servidor de telefone:",
    "PartitionsLabel": "Partições:",
    "ScopeFiltering_SectionHeader": "Filtragem de Escopo",
    "NAME": "ScopeFiltering"
}